<template>
<b-row class="text-center">
    <div class="form-group col-lg-12 col-sm-12">
        <div class="input-group">
            <span class="input-group-btn">
                <!-- <b-button block variant="primary" @click.prevent="newDevice">New Dev</b-button> -->
                <router-link v-if="this.$can('device','create')" :to="{name: 'Add Device'}" class="btn btn-primary">Add +</router-link>

            </span>
            <input type="text" v-model="filterText" class="form-control" @keyup.enter="doFilter" placeholder="Name, MAC or Serial">
            <span class="input-group-btn">
                <button type="button" class="btn btn-primary" @click.prevent="doFilter"><i class="fa fa-search"></i></button>
                <button type="button" class="btn btn-primary" @click.prevent="resetFilter"><i class="fa fa-remove"></i></button>
                <button type="button" class="btn btn-primary" @click.prevent="reload"><i class="fa fa-refresh"></i></button>
            </span>
            <span v-if="show_accts">
                <b-form-select key="account" v-model="selected_acct" :options="accounts_opts" id="account_id" name="Account ID" value-field="id" text-field="account" @change="setAccount">
                    <template #first>
                        <b-form-select-option >All Accounts</b-form-select-option>
                    </template>
                </b-form-select>
            </span>

        </div>
    </div>

</b-row>
</template>

<script>
export default {
    data() {
        return {
            filterText: '',
            selected_acct: '',
            accounts_opts: [],
            show_accts: false,
        }
    },
    methods: {
        reload() {
            // this.$parent.refresh();
            // this.$refs.vuetable.reload()
            location.reload();
        },
        doFilter() {
            this.$events.fire('filter-set', this.filterText)
        },
        resetFilter() {
            this.filterText = ''
            this.$events.fire('filter-reset')
        },
        setAccount() {
            // console.log('ACCountID: ' + this.selected_acct); 
            this.$events.fire('account-set', this.selected_acct)
        },
        newDevice() {
            console.log('Message #: 12890')
        },
    },
    created() {
        this.loading = true;
        let uri = `/api/accounts/selectList`;
        axios.get(uri).then((response) => {

            let a = response.data.data.account_opts;

            if (!a || a.length === 0) {
                this.accounts_opts = [];
            } else {
                this.accounts_opts = a;
                this.show_accts = true;

            }
            this.loading = false;

        });
    },
    computed: {},

}
</script>
